export type TopicHeat = "高热" | "升温" | "新收录";

export type Topic = {
  id: string;
  title: string;
  category: string;
  heat: TopicHeat;
  heatScore: number;
  deadline: string;
  summary: string;
  sampleTitle: string;
  angles: string[];
  leads: number;
  image: string;
};

export const topicCategories = [
  "全部选题",
  "民生现场",
  "消费维权",
  "行业职场",
  "科技互联网",
  "城市生活",
  "文化娱乐",
];

export const topics: Topic[] = [
  {
    id: "t01",
    title: "老旧小区加装电梯「装到一半停工」调查",
    category: "民生现场",
    heat: "高热",
    heatScore: 96,
    deadline: "本周内优先",
    summary:
      "多地出现加装电梯工程款收了、井道立了，却因资金方与业委会分歧长期停工。需要具体小区的时间线与缴费凭证。",
    sampleTitle: "电梯井立了两年没通一台，这个小区卡在了哪一笔钱上",
    angles: ["费用分摊方案如何谈崩", "施工方与业委会的合同细节", "老年住户的出行困境"],
    leads: 128,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20an%20unfinished%20elevator%20shaft%20frame%20outside%20an%20old%20Chinese%20residential%20building%2C%20soft%20afternoon%20light%2C%20muted%20earth%20tones%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-old-community-elevator&orientation=landscape",
  },
  {
    id: "t02",
    title: "临期食品折扣店「改标再卖」乱象",
    category: "消费维权",
    heat: "高热",
    heatScore: 94,
    deadline: "长期征集",
    summary:
      "折扣零食店用喷码机覆盖原生产日期、临期品按正价卖。需要门店实拍、购物小票与同批次对比证据。",
    sampleTitle: "明明写着还有半年到期，为什么撕开标签是另一个日期",
    angles: ["改码手法与设备来源", "加盟商被压货的处境", "消费者维权卡在哪一步"],
    leads: 96,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20shelves%20packed%20with%20snack%20packages%20in%20a%20small%20discount%20grocery%20store%2C%20soft%20indoor%20lighting%2C%20muted%20warm%20tones%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-snack-discount-store&orientation=landscape",
  },
  {
    id: "t03",
    title: "预制菜进校园：家长的顾虑与学校的选择",
    category: "民生现场",
    heat: "升温",
    heatScore: 88,
    deadline: "开学季征集",
    summary:
      "学校食堂更换供餐方式后，家长对食材来源与加工方式产生疑问。需要供餐合同、菜单与家长沟通记录。",
    sampleTitle: "一份没有配料表的午餐，让三百位家长坐不住了",
    angles: ["供餐企业资质与招标过程", "家长沟通会上的分歧", "孩子的实际用餐反馈"],
    leads: 74,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20a%20clean%20school%20canteen%20tray%20with%20simple%20prepared%20meals%2C%20soft%20natural%20light%2C%20muted%20warm%20neutral%20tones%2C%20calm%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-school-meal-prep&orientation=landscape",
  },
  {
    id: "t04",
    title: "外卖骑手「超时罚款」背后的算法规则",
    category: "行业职场",
    heat: "高热",
    heatScore: 92,
    deadline: "长期征集",
    summary:
      "骑手称平台按分钟扣款、申诉通道形同虚设。需要扣款截图、申诉记录与区域站点的管理方式。",
    sampleTitle: "迟到四分钟扣掉一顿饭钱，申诉按钮点了一百次",
    angles: ["罚款规则与申诉流程", "站点管理的灰色操作", "骑手群体的真实收入账"],
    leads: 156,
    image:
      "https://readdy.ai/api/search-image?query=Documentary%20photo%20of%20a%20delivery%20rider%20parked%20in%20a%20narrow%20city%20alley%20at%20dusk%2C%20warm%20street%20lights%2C%20muted%20earth%20tones%2C%20cinematic%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-delivery-rider-alley&orientation=landscape",
  },
  {
    id: "t05",
    title: "直播带货「全网最低价」话术拆解",
    category: "消费维权",
    heat: "升温",
    heatScore: 85,
    deadline: "长期征集",
    summary:
      "直播间宣称的最低价被发现在其他渠道更低，比价规则含糊。需要直播录屏、价格截图与订单实付记录。",
    sampleTitle: "主播喊了三遍「全网最低」，我在隔壁平台便宜了一半",
    angles: ["比价话术的规则漏洞", "保价承诺兑现情况", "退货难的真实流程"],
    leads: 88,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20photo%20of%20a%20home%20studio%20live%20streaming%20setup%20with%20ring%20light%20and%20product%20samples%20on%20a%20desk%2C%20soft%20evening%20lighting%2C%20muted%20warm%20tones%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-livestream-selling&orientation=landscape",
  },
  {
    id: "t06",
    title: "AI 换脸诈骗的新套路与受骗者自述",
    category: "科技互联网",
    heat: "高热",
    heatScore: 95,
    deadline: "本周内优先",
    summary:
      "骗子用合成视频冒充亲友、客服或领导实施转账。需要聊天记录、转账凭证与受骗过程的完整时间线。",
    sampleTitle: "视频里那个「儿子」，其实是一段二十秒的合成画面",
    angles: ["诈骗话术的完整链路", "平台风控的拦截盲区", "受骗者事后追款的难点"],
    leads: 132,
    image:
      "https://readdy.ai/api/search-image?query=Moody%20photo%20of%20a%20smartphone%20screen%20glowing%20with%20a%20video%20call%20interface%20on%20a%20dark%20wooden%20desk%2C%20warm%20amber%20rim%20light%2C%20cinematic%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-ai-fraud-phone&orientation=landscape",
  },
  {
    id: "t07",
    title: "网红打卡地「滤镜骗局」实地对比",
    category: "城市生活",
    heat: "新收录",
    heatScore: 78,
    deadline: "长期征集",
    summary:
      "社交平台上爆火的景点，实景与照片差距巨大。需要同一机位的实拍对比与游客真实反馈。",
    sampleTitle: "排了两小时队，我拍到了那片「不存在的花海」",
    angles: ["宣传图与实景的差距", "门票与二次消费套路", "当地商户的无奈"],
    leads: 61,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20photo%20of%20an%20empty%20tourist%20viewing%20platform%20with%20faded%20decorations%20and%20a%20distant%20hazy%20landscape%2C%20soft%20daylight%2C%20muted%20earthy%20tones%2C%20quiet%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-tourist-spot-disappoint&orientation=landscape",
  },
  {
    id: "t08",
    title: "教培机构退费难：家长维权实录",
    category: "消费维权",
    heat: "升温",
    heatScore: 84,
    deadline: "长期征集",
    summary:
      "机构停课后退费一拖再拖，分期与转课方案让家长两难。需要合同、缴费记录与沟通群里的承诺截图。",
    sampleTitle: "说好三十天退款，第九十天客服还在让我「再等等」",
    angles: ["机构资金链与经营变化", "退费条款里的隐藏约定", "分期退款的兑现情况"],
    leads: 79,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20photo%20of%20an%20empty%20classroom%20with%20stacked%20chairs%20and%20closed%20books%20on%20desks%2C%20soft%20window%20light%2C%20muted%20neutral%20tones%2C%20quiet%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-tutoring-refund&orientation=landscape",
  },
  {
    id: "t09",
    title: "新能源车「续航虚标」冬季实测",
    category: "科技互联网",
    heat: "新收录",
    heatScore: 76,
    deadline: "冬季征集",
    summary:
      "标称续航与实际里程差距明显，车主抱怨充电体验。需要仪表数据、充电记录与同一路线对比。",
    sampleTitle: "标称六百公里，零下的早晨我只开到了三百二",
    angles: ["标称与实测的数据差", "售后解释与升级承诺", "车主社群的集体反馈"],
    leads: 58,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20photo%20of%20an%20electric%20car%20charging%20at%20an%20outdoor%20station%20on%20a%20cold%20misty%20morning%2C%20soft%20grey%20light%2C%20muted%20cool%20neutral%20tones%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-ev-range-test&orientation=landscape",
  },
  {
    id: "t10",
    title: "租房「二房东」跑路事件追踪",
    category: "城市生活",
    heat: "高热",
    heatScore: 90,
    deadline: "本周内优先",
    summary:
      "二房东收齐年付租金后失联，房东与租客同时受损。需要合同、转账流水与被清退租客的现场情况。",
    sampleTitle: "交了一年的房租，第七十三天我被断了水电",
    angles: ["二房东的资金腾挪方式", "房东与租客的对立处境", "长租平台的监管责任"],
    leads: 143,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20photo%20of%20a%20quiet%20apartment%20doorway%20with%20a%20paper%20notice%20taped%20on%20it%20and%20shoes%20outside%2C%20soft%20hallway%20light%2C%20muted%20warm%20tones%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-renting-sublet&orientation=landscape",
  },
  {
    id: "t11",
    title: "影视剧组「阴阳合同」线索征集",
    category: "文化娱乐",
    heat: "升温",
    heatScore: 82,
    deadline: "长期征集",
    summary:
      "剧组工作人员反映报酬与合同不符、加班无补偿。需要合同版本对比、聊天记录与结算凭证。",
    sampleTitle: "同一份工作两份合同，差价去了哪里",
    angles: ["两份合同的条款差异", "剧组用工的常见操作", "从业者的维权路径"],
    leads: 67,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20photo%20of%20a%20film%20set%20at%20night%20with%20lighting%20rigs%20and%20folders%20of%20paperwork%20on%20a%20director%20chair%2C%20cinematic%20amber%20light%2C%20muted%20tones%2C%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-film-crew-contract&orientation=landscape",
  },
  {
    id: "t12",
    title: "社区团购团长「被欠款」困局",
    category: "行业职场",
    heat: "新收录",
    heatScore: 74,
    deadline: "长期征集",
    summary:
      "平台调整结算规则后，团长垫付的货款迟迟不到账。需要结算后台截图、佣金明细与平台沟通记录。",
    sampleTitle: "替平台垫了三万块，团长的佣金变成了「待核销」",
    angles: ["结算规则的突然变化", "团长的垫资风险", "平台与团长的责任边界"],
    leads: 52,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20photo%20of%20cardboard%20boxes%20of%20groceries%20stacked%20in%20a%20small%20residential%20pickup%20corner%2C%20soft%20daylight%2C%20muted%20warm%20neutral%20tones%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=topic-community-group-buying&orientation=landscape",
  },
];